/**
 * Forms
 */


$(function () {

    if ($('.js-form').length) {

        $('.js-form').each(function () {
            $(this).validate({
                errorClass: 'js-form-error',
                validClass: 'js-form-valid',
                submitHandler: function (form) {
                    $('.js-submit-button').prop('disabled', true);
                    $(form).addClass('js-form--loading');
                    form.submit();
                }
            });
        });

        $('.c-hero-form__input').on('focus', function () {
            $(this).addClass('has-focus').prev('.c-hero-form__label').addClass('is-floating');
        });

        $('.c-hero-form__input').on('blur', function () {
            $(this).removeClass('has-focus');
            if ($(this).val() == '') {
                $(this).prev('.c-hero-form__label').removeClass('is-floating')
            }
        });

        $.validator.methods.email = function (value, element) {
            return this.optional(element) || /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i.test(value);
        }

        jQuery.validator.addMethod('date', function (value, element) {
            return this.optional(element) || /^((0?[1-9])|1[012])\/(([0-2][0-9])|([1-9])|(3[0-1]))\/(19|20)[0-9]{2}$/.test(value);
        }, 'Please enter a valid date.');

        jQuery.validator.addMethod('over19', function (value, element) {
            currentYear = new Date().getFullYear();
            value = currentYear - (value.substr(value.length - 4));
            if (value >= 19) {
                return true;
            } else {
                return false;
            }
        }, 'The person\' age must be 19 or over.');

        jQuery.validator.addMethod('under100', function (value, element) {
            currentYear = new Date().getFullYear();
            value = currentYear - (value.substr(value.length - 4));
            if (value < 100) {
                return true;
            } else {
                return false;
            }
        }, 'Please enter a valid date.');

        $('.form').validate({
            errorClass: 'form__error',
            submitHandler: function (form) {
                $(form).addClass('form_loading');
                form.submit();
            }
        });

        if ($('#noOfPeople').length) {
            $('#noOfPeople').rules('add', {
                required: true,
                messages: {
                    required: 'Enter household size'
                }
            });
        }
        if ($('#householdIncome').length) {
            $('#householdIncome').rules('add', {
                required: true,
                messages: {
                    required: 'Enter annual household income'
                }
            });
        }
        if ($('#firstName').length) {
            $('#firstName').rules('add', {
                required: true,
                minlength: 2,
                messages: {
                    required: 'Enter your first name'
                }
            });
        }
        if ($('#lastName').length) {
            $('#lastName').rules('add', {
                required: true,
                minlength: 2,
                messages: {
                    required: 'Enter your last name'
                }
            });
        }
        if ($('#email').length) {
            $('#email').rules('add', {
                required: true,
                minlength: 3,
                maxlength: 255,
                messages: {
                    required: 'Enter your email'
                }
            });
        }
        if ($('#phone').length) {
            $('#phone').rules('add', {
                required: true,
                minlength: 12,
                maxlength: 12,
                messages: {
                    required: 'Enter your phone number',
                    minlength: 'You must enter 10 digits',
                    maxlength: 'You must enter 10 digits',
                }
            });
        }

        if ($('#zipcode').length) {
            $('#zipcode').rules('add', {
                required: true,
                digits: true,
                minlength: 3,
                maxlength: 5,
                remote: {
                    url: 'https://thorv2.confiejarvis.com/thor/javascript?',
                    data: {
                        zipcode: function () { return $('#zipcode').val(); }
                    },
                    dataFilter: function (data) {
                        if (data === "1") {
                            return '"true"';
                        }
                        return '"Enter a valid zip code"';
                    }
                },
                messages: {
                    required: 'Enter your zip code'
                }
            });
        }
        if ($('#zipcode-quote').length) {
            $('#zipcode-quote').rules('add', {
                required: true,
                digits: true,
                minlength: 3,
                maxlength: 5,
                remote: {
                    url: 'https://thorv2.confiejarvis.com/thor/javascript?',
                    data: {
                        zipcode: function () { return $('#zipcode-quote').val(); }
                    },
                    dataFilter: function (data) {
                        if (data === "1") {
                            return '"true"';
                        }
                        return '"Enter a valid zip code"';
                    }
                },
                messages: {
                    required: 'Enter your zip code'
                }
            });
        }
    }
});